import Grid from '@mui/material/Grid';
import theme from '../../theme';

export default function Work(props) {
    return (
        <div style={{ fontFamily: theme.typography.main_en.fontFamily }}
            className='ease-[1] mb-4 active:bg-[#dfdfdf]'>
            <a href={props.path}>
                <Grid container spacing={0} className='border border-[#d7d7d7] rounded-lg shadow-sm'>
                    <Grid size={6} className='flex justify-center items-center'>
                        <div className='rounded-l-lg mx-1 my-2 w-[100%] aspect-square flex justify-center items-center'>
                            <img src={props.img_path} alt={props.alt} className='px-2 py-0 object-cover' />
                        </div>
                    </Grid>
                    <Grid size={6}>
                        <div className='flex items-center justify-end h-[100%] rounded-none shadow-none text-right text-black'>
                            <div className='mx-2 my-2'>
                                <small>{props.title}</small>
                                <p className='text-xl'>{props.date}</p>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </a>
        </div>
    );
}